import React from "react";
import { Flex, Box, Heading, Text } from "@chakra-ui/react";
import { Bar } from "react-chartjs-2";

function BarChart(props) {
  //const graphWidth = props.data.labels.length > 30 ? '90vw' : '42vw';
  const data = {
    labels: props.data.labels,
    datasets: [
      {
        label: props.lable,
        data: props.data.data,
        backgroundColor: props.color,
        maxBarThickness: 30,
      },
    ]
  };
  let options = {
    scales: {
      yAxes: {
        title: {
          display: true,
          text: props.yAxesLabel
        },
        ticks: {
          precision: 0
        }
      },
      xAxes: {
       
      }
    },     
    maintainAspectRatio: false
  }

  return (
    <Flex direction="row">
      <Box
        p={12}
        pb={14}
        minW={350}
        w={'43vw'}
        h={"50vh"}
        borderWidth="1px" 
        borderRadius="lg"
        borderColor="#f5f5f5"
        boxShadow="xl"
        backgroundColor='#f7f7fa'
      >
        <Heading color="black" as="h4" size="sm">
          {props.heading}
        </Heading>
        <Bar options={options} data={data} />
        <Text align="center" fontSize="ms" p ={2}>Total case : {props.total}</Text>
      </Box>
    </Flex>
  );
}

export default React.memo(BarChart);
